import React from 'react';
import { Link } from 'react-router-dom';

/**
 * A required tick box with a sentence and a link to a legal page (opens in a new tab so a half-filled form
 * is not lost). Unchecked by default; the page keeps the state and must also block the submit on it: the
 * `required` attribute here stops the browser form, the backend refuses the request without consent anyway.
 *
 * `children` is the sentence before the link; `linkText` the link label.
 */
export default function ConsentCheckbox({ id, checked, onChange, to, linkText, children, testId, className = '' }) {
  return (
    <div className={`flex items-start gap-2.5 ${className}`}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        required
        data-testid={testId}
        className="mt-0.5 h-4 w-4 flex-shrink-0 accent-[var(--accent)] cursor-pointer"
      />
      <label htmlFor={id} className="text-text-secondary text-xs leading-relaxed cursor-pointer">
        {children}
        {to && (
          <>
            {' '}
            <Link to={to} target="_blank" rel="noopener noreferrer" className="text-accent underline underline-offset-2 hover:no-underline" onClick={(e) => e.stopPropagation()}>
              {linkText}
            </Link>
          </>
        )}
        {' *'}
      </label>
    </div>
  );
}
